<template>
    <v-row>      
      <div class="col-md-12 home-box">
        <Breadcrumbs :title="'Suppliers'"></Breadcrumbs>
        <SupplierGrid></SupplierGrid>
      </div>
      <div class="col-md-12 home-tabs-body">
      </div>
    </v-row>
  </template>
  
  <script>
  
  import SupplierGrid from "@/components/suppliers/SupplierGrid.vue";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "Suppliers",
    components: {
      SupplierGrid,
      Breadcrumbs
    },
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
  
    },
  
    methods: {
  
    },
  
  };
  </script>
  